// extracted by mini-css-extract-plugin
export default {"dialog":"CommonDialog_dialog__RVdkn","title":"CommonDialog_title__BTHNe","content":"CommonDialog_content__TEyLN","actions":"CommonDialog_actions__DL5wR"};